import Vue from 'vue'
import ACTIONS from '../_actions.json'
import {generateString, randomRange, createArray, getRandomInArray} from '@/utils/base.js'

const intervalBetweenAction = 10000 + 4500
const minGameTime = 30000
const bubbleWait = 4500

export default {
    namespaced: true,
    state: {
        minute: 0,
        regions: [],
        actions: []
    },
    getters: {
        regionById: state => regionId => state.regions.find(region => region.id === regionId),
        actionByRegion: (state, getters) => regionId => getters.availableActions.filter(action => (action.region === regionId))[0],
        instructionByMinute: () => minute => ACTIONS.map.find(step => {
            if (step.minute.length === 1) {
                return step.minute[0] === minute
            } else if (step.minute.length === 2) {
                return (step.minute[0] < minute && step.minute[1] > minute || step.minute[0] === minute || step.minute[1] === minute)
            }
        }),
        availableActions: (state, getters, rootState) => {
            const time = rootState.control.time
            return state.actions.filter(action => (action.activateAt < time))
        }
    },
    actions: {
        update ({state, rootState, getters, commit, dispatch}) {
            const minute = rootState.control.minute
            const time = rootState.control.time

            if (rootState.progress.progress >= 85) {
                if (!state.actions.length) {
                    const instruction = getters.instructionByMinute(12)
                    const range = [time + (11 * 1000), time + (12 * 1000)]
                    dispatch('createActionByInfo', {instruction, range})
                }
            }
            // Create Actions
            else if (minute !== state.minute) {
                commit('minute', minute)
                const instruction = getters.instructionByMinute(minute)
                const rangeStart = time < minGameTime ? (minGameTime - time) : time
                const range = [rangeStart, time + (60 * 1000)]
                dispatch('createActionByInfo', {instruction, range})
            }

            // Update Actions
            getters.availableActions.forEach(action => {
                const updates = {}
                updates.waitTo = (action.activateAt + bubbleWait) - time

                if (updates.waitTo <= 0) {
                    dispatch('balance/remove', action.config.lose, {root: true})
                    dispatch('history/push', {message: `Action timeout -${action.config.lose}balls`, theme: 'warn'}, {root: true})
                    commit('removeAction', action.id)
                } else {
                    commit('updateAction', {id: action.id, updates})
                }
            })

            if (!window._action) {
                window._action = id => {
                    const actionData = ACTIONS.actions.find(item => item.id === id)

                    commit('action', {
                        id: generateString(6),
                        place: {top: 10, left: 10},
                        waitTo: 20000,
                        region: rootState.regions.regions[0].id,
                        data: {
                            id: actionData.id,
                            title: actionData.title,
                            type: actionData.type,
                            action: actionData.items ? getRandomInArray(actionData.items) : null
                        },
                        activateAt: time,
                        config: {
                            id,
                            right: 3,
                            lose: 0,
                            time: 90000
                        }
                    })
                }
            }
        },

        createActionByInfo ({commit, rootState}, {instruction, range}) {
            const regions = rootState.regions.regions
            const actions = instruction.once ? [getRandomInArray(instruction.actions)] : instruction.actions
            const actionsRegions = {}

            // select actions
            actions.forEach(action => {
                const region = getRandomInArray(regions)
                const actionData = ACTIONS.actions.find(item => item.id === action.id)
                const key = `id${region.id}`
                const actionInstance = {
                    id: generateString(6),
                    config: {...action},
                    place: {
                        top: randomRange(region.zone[0], region.zone[0] + region.zone[3]),
                        left: randomRange(region.zone[1], region.zone[1] + region.zone[2])
                    },
                    region: region.id,
                    waitTo: bubbleWait,
                    data: {
                        id: actionData.id,
                        title: actionData.title,
                        type: actionData.type,
                        action: actionData.items ? getRandomInArray(actionData.items) : null
                    }
                }

                actionsRegions[key] = actionsRegions[key] || []
                actionsRegions[key].push(actionInstance)
            })

            // set time activate
            Object.keys(actionsRegions).forEach(regionId => {
                const actionsList = actionsRegions[regionId]
                const ranges = createRanges(range, actionsList.length)
                actionsList.forEach((actionInstance, i) => {
                    const range = ranges[i]
                    actionInstance.activateAt = randomRange(range[0], range[1])
                    commit('action', actionInstance)
                })
            })
        },

        removeAction ({commit}, id) {
            commit('removeAction', id)
        },

        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        minute (state, minute) {
            state.minute = minute
        },

        updateAction (state, {id, updates = {}}) {
            const regionIndex = state.actions.findIndex(action => action.id === id)
            const action = state.actions[regionIndex]
            Vue.set(state.actions, regionIndex, {
                ...action,
                ...updates
            })
        },

        removeAction (state, id) {
            const index = state.actions.findIndex(action => action.id === id)
            state.actions.splice(index, 1)
        },

        action (state, actionInstance) {
            state.actions.unshift(actionInstance)
        },

        reset (state) {
            state.regions = []
            state.actions = []
            state.gameMin = 0
        }
    }
}

function createRanges (range, length) {
    const offset = intervalBetweenAction / 2
    const step = (range[1] - range[0]) / length
    return createArray(length).map((item, i) => {
        const start = range[0] + (step * i)
        return [
            start + offset,
            start + step - offset
        ]
    })
}
